$(document).ready(function ($) {
  // Subcategoria
  $(".subcategoria-icone").each(function (index) {
    $(this).on("click mouseenter", function (e) {
      console.log(e.type);
      if ($(".subcategoria").eq(index).hasClass("ocultado")) {
        $(".subcategoria").eq(index).slideDown().removeClass("ocultado");
      } else {
        if (e.type != "mouseenter") {
          $(".subcategoria").eq(index).slideUp().addClass("ocultado");
        }
      }
    });
  });

  // Categorais mobile
  $(".categorias-mobile select").on("change", function (e) {
    console.log(e.target);
    window.location.href = e.target.value;
  });
});
